import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
          数字能量分析 - 风水号码 隐私政策
        </h1>

        <div className="text-sm text-gray-500 mb-8 text-center">
          最后更新时间：2025年5月12日
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">简介</h2>
            <p className="text-gray-700">
              欢迎使用数字能量分析 -
              风水号码！本隐私政策概述了当您使用我们的移动应用程序时，我们如何收集、使用和保护您的个人信息。我们致力于保护您的隐私，建议您仔细阅读本政策，以了解您的数据将如何被处理。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              我们收集的信息
            </h2>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              2.1 个人信息：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                当您创建账户时，我们可能会收集您的姓名、电子邮件地址和其他相关详细信息。
              </li>
              <li>
                如果您选择使用第三方服务登录，我们可能会从这些服务中收集信息。
              </li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              2.2 使用数据：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                我们可能会收集有关您如何与应用程序交互的信息，包括访问的页面、使用的功能和其他使用模式。
              </li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              2.3 设备信息：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                我们可能会收集有关您使用的设备的信息，例如设备类型、操作系统和唯一设备标识符。
              </li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              2.4 位置信息：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                在您同意的情况下，我们可能会收集位置信息以提供基于位置的服务。
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              我们如何使用您的信息
            </h2>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              3.1 个性化：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                我们使用您的信息来个性化您在应用程序中的体验，提供相关的内容和功能。
              </li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              3.2 通信：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                我们可能会使用您的联系信息向您发送重要更新、新闻通讯或营销材料。您可以随时选择退出这些通信。
              </li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">
              3.3 分析：
            </h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>
                我们使用分析工具来了解用户如何与我们的应用程序交互，帮助我们改进其功能和用户体验。
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              数据安全
            </h2>
            <p className="text-gray-700">
              我们优先考虑您信息的安全性，并采用行业标准措施来保护其免受未经授权的访问、披露、更改或破坏。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              第三方服务
            </h2>
            <p className="text-gray-700">
              我们的应用程序可能与第三方服务集成。请查看这些服务的隐私政策，因为我们不对其做法负责。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              儿童隐私
            </h2>
            <p className="text-gray-700">
              我们的应用程序不适用于13岁以下的用户。我们不会故意收集儿童的个人信息。如果您是父母或监护人，并且认为您的孩子向我们提供了信息，请联系我们，我们将采取适当的行动。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              隐私政策的变更
            </h2>
            <p className="text-gray-700">
              我们保留更新隐私政策的权利。任何变更都会在此页面上反映，我们建议您定期查看政策。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              联系我们
            </h2>
            <p className="text-gray-700">
              如果您对本隐私政策有任何问题或疑虑，请通过{" "}
              <a
                href="mailto:scott@bolt-interactive.com"
                className="text-blue-600 hover:text-blue-800"
              >
                scott@bolt-interactive.com
              </a>{" "}
              联系我们。
            </p>
          </section>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-gray-700">
              通过使用数字能量分析 -
              风水号码，您同意本隐私政策中概述的条款。感谢您信任我们处理您的信息。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
